import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Importa o useNavigate
import "../styles/SideBar.css";
import logo from "../../assets/logo1.png";

import { MdAddToPhotos, MdSpaceDashboard } from "react-icons/md";
import { FaUserGroup, FaGear } from "react-icons/fa6";
import { IoLogOut } from "react-icons/io5";
import { FaChevronDown, FaGlobe, FaFileDownload } from "react-icons/fa";
import { BsFillClipboard2DataFill } from "react-icons/bs";
import { FaListUl } from "react-icons/fa6";

const SideBar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate(); // Instancia o useNavigate

  const handleClick = (item) => {
    setActiveMenu(activeMenu === item ? null : item);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.removeItem("auth"); // Remove o token ou flag de autenticação
    navigate("/"); // Redireciona para o site público
  };

  return (
    <aside className="sidebar">
      <header>
        <img src={logo} alt="Logo" className="logoSide" />
      </header>
      <ul>
        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/panel/dashboard")}
          >
            <MdSpaceDashboard />
            <p>Dashboard</p>
          </button>
        </li>

        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/panel/lista-imoveis")}
          >
            <FaListUl />
            <p>Todos Imóveis</p>
          </button>
        </li>

        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/panel/AddImovel")}
          >
            <MdAddToPhotos />
            <p>Adicionar Imóvel</p>
          </button>
        </li>

        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/panel/cadastrar-corretor")}
          >
            <FaUserGroup />
            <p>Cadastros</p>
          </button>
        </li>

        <li>
          <button
            className={`asideButton ${
              activeMenu === "gerenciar" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleClick("gerenciar")}
          >
            <BsFillClipboard2DataFill />
            <p>Gerenciar</p>
            <FaChevronDown className="chevron-icon" />
          </button>
          <div
            className={`sub-menu ${activeMenu === "gerenciar" ? "open" : ""}`}
          >
            <ul>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() =>
                    handleNavigation("/panel/comprovantes-aluguel")
                  }
                >
                  <p>Comprovantes Aluguéis</p>
                </button>
              </li>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/comprovantes-venda")}
                >
                  <p>Comprovantes Vendas</p>
                </button>
              </li>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/clientes")}
                >
                  <p>Clientes</p>
                </button>
              </li>
            </ul>
          </div>
        </li>

        <li>
          <button
            className={`asideButton ${
              activeMenu === "documentos" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleClick("documentos")}
          >
            <FaFileDownload />
            <p>Documentos</p>
            <FaChevronDown className="chevron-icon" />
          </button>
          <div
            className={`sub-menu ${activeMenu === "documentos" ? "open" : ""}`}
          >
            <ul>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/ficha-captacao")}
                >
                  <p>Ficha de Captação</p>
                </button>
              </li>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/emprestimo-chaves")}
                >
                  <p>Empréstimo de Chaves</p>
                </button>
              </li>
             
              {/* <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/proposta-venda")}
                >
                  <p>Proposta de Venda</p>
                </button>
              </li>
              <li>
                <button
                  className="asideButton"
                  type="button"
                  onClick={() => handleNavigation("/panel/plaquinha-chaves")}
                >
                  <p>Plaquinha de Chaves</p>
                </button>
              </li> */}
            </ul>
          </div>
        </li>

        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/panel/Config")}
          >
            <FaGear />
            <p>Configurações</p>
          </button>
        </li>

        <li>
          <button
            className="asideButton"
            type="button"
            onClick={() => handleNavigation("/")}
          >
            <FaGlobe />
            <p>Site</p>
          </button>
        </li>

        <li>
          <button className="asideButton" type="button" onClick={handleLogout}>
            <IoLogOut />
            <p>Sair da Conta</p>
          </button>
        </li>
      </ul>
    </aside>
  );
};

export default SideBar;
